import type { Zone } from '@seek/audience-zones';
import type { Locale } from '@seek/ca-myprofile-utils';

import type { Environment, Site } from 'src/types';

export interface EnvConfig {
  SEEK_ENV: Environment;
  MOCK_API_URL: string;
  ANALYTICS_ENV: string;
  ANALYTICS_IS_ENABLED: boolean;
  ANALYTICS_DEBUG: boolean;
  DATADOG_RUM_ENABLED: boolean;
  DATADOG_BROWSER_LOG_ENABLED: boolean;
  TRACKJS_ENABLED: boolean;
  IMPRESSION_TRACKING_ENABLED: boolean;
  IMPRESSION_TRACKING_URL: string;
  METRICS_URL: string;
  METRICS_IS_ENABLED: boolean;
  PUBLIC_RESOURCE_API: string;
  CANDIDATE_GRAPH_DARK_PROD_URL: string;
}

export type Config = EnvConfig & {
  site: Site;
  locale: Locale;
  theme?: string;
  zone: Zone;
  version: string;
};

declare global {
  interface Window {
    SEEK_DEV_SERVER: boolean;
    APP_CONFIG: Config;
    Cypress: Record<string, unknown>;
    SEEK_TEST: boolean;
  }
}

const isWindowDefined =
  typeof window !== 'undefined' && !window.SEEK_DEV_SERVER && window.APP_CONFIG;

export const SEEK_ENV = isWindowDefined ? window.APP_CONFIG.SEEK_ENV : '';
export const MOCK_API_URL = isWindowDefined
  ? window.APP_CONFIG.MOCK_API_URL
  : '';
export const ANALYTICS_ENV = isWindowDefined
  ? window.APP_CONFIG.ANALYTICS_ENV
  : '';
export const ANALYTICS_IS_ENABLED = isWindowDefined
  ? window.APP_CONFIG.ANALYTICS_IS_ENABLED
  : false;
export const ANALYTICS_DEBUG = isWindowDefined
  ? window.APP_CONFIG.ANALYTICS_DEBUG
  : false;
export const METRICS_URL = isWindowDefined ? window.APP_CONFIG.METRICS_URL : '';
export const METRICS_IS_ENABLED = isWindowDefined
  ? window.APP_CONFIG.METRICS_IS_ENABLED
  : '';
export const TRACKJS_ENABLED = isWindowDefined
  ? window.APP_CONFIG.TRACKJS_ENABLED
  : false;
export const IMPRESSION_TRACKING_ENABLED = isWindowDefined
  ? window.APP_CONFIG.IMPRESSION_TRACKING_ENABLED
  : false;
export const IMPRESSION_TRACKING_URL = isWindowDefined
  ? window.APP_CONFIG.IMPRESSION_TRACKING_URL
  : '';
export const CANDIDATE_GRAPH_DARK_PROD_URL = isWindowDefined
  ? window.APP_CONFIG.CANDIDATE_GRAPH_DARK_PROD_URL
  : '';
